// src/pages/ErrorPage.jsx
import React from "react";

const ErrorPage = () => (
  <div className="text-center p-5">
    <h1>500 - Server Error</h1>
    <p>Sorry, something went wrong. Please try again later.</p>
  </div>
);

export default ErrorPage;
